<template>
<div>

    <m-select-currency
        label="Default Currency"
        v-model="default_currency"
        v-on:input="updateSettings()"
    />

    <m-edit-text
        label="Charges Show As (optional)"
        v-model="bill_from_charges_show_as"
        :read_only="!can_write"
        v-on:input="updateSettings()"
    />

    <v-select
        label="Default age verification"
        v-model="default_age_verification_requirement"
        :items="possible_age_verification_requirements"
        :read_only="!can_write"
        v-on:input="updateSettings()"
    />

    <v-checkbox
        label="Accept Visa"
        v-model="accept_visa"
        v-on:change="updateSettings()"
        style="margin-bottom: -25px"
    />

    <v-checkbox
        label="Accept Mastercard"
        v-model="accept_mastercard"
        v-on:change="updateSettings()"
        style="margin-bottom: -25px"
    />

    <v-checkbox
        label="Accept American Express"
        v-model="accept_amex"
        v-on:change="updateSettings()"
        style="margin-bottom: -25px"
    />

    <v-checkbox
        label="Accept Discover Card"
        v-model="accept_discover"
        v-on:change="updateSettings()"
        style="margin-bottom: -25px"
    />

    <v-checkbox
        label="Accept ACH Payments (Bank Transfers)"
        v-model="accept_ach"
        v-on:change="updateSettings()"
    />

    <m-edit-text
        label="Branded URL Portion (optional)"
        v-model="vanity_url_portion"
        :read_only="!can_write"
        v-on:input="updateSettings()"
        show_hint_everywhere
        :hint="vanity_url_hint"
        vanity_url_portion
        optional
    />
   
</div>
</template>

<script>
const _ = require('lodash');

const TestData = require("@/js/TestData.js");

export default {
    props: {
        profile: {
            type: Object,
            default: function() { return {}; }
        },
    },

    data() {
        return {
            bill_from_charges_show_as: null,
            accept_visa: false,
            accept_mastercard: false,
            accept_amex: false,
            accept_discover: false,
            accept_ach: false,
            default_currency: 'USD',
            default_age_verification_requirement: 'none',
            vanity_url_portion: null,

            possible_age_verification_requirements: [
                { 'text' : 'None', 'value' : 'none' },
                { 'text' : 'Checkbox', 'value' : 'checkbox' },
                { 'text' : 'Birthdate', 'value' : 'birthdate' },
            ],
        }
    },

    mounted () {
        this.setBooleansFromProfile();
    },

    methods: 
    {
        updateSettings()
        {
            let bill_from_charges_show_as = this.bill_from_charges_show_as;
            if ( bill_from_charges_show_as != null && bill_from_charges_show_as.trim().length == 0 ) bill_from_charges_show_as = null;

             let payment_settings = {
                'bill_from_charges_show_as' : bill_from_charges_show_as,
                'accept_visa' : this.accept_visa,
                'accept_ach': this.accept_ach,
                'accept_mastercard' : this.accept_mastercard,
                'accept_amex' : this.accept_amex,
                'accept_discover' : this.accept_discover,
                'default_currency': this.default_currency,
                'default_age_verification_requirement' : this.default_age_verification_requirement,
                'vanity_url_portion' : this.vanity_url_portion,
            };  

            let new_organization_acount = _.cloneDeep(this.profile.organization_account);
            new_organization_acount.payment_settings = payment_settings;

            this.$emit('upsert-organization-account',new_organization_acount);
        },


        setBooleansFromProfile()
        {
            if ( this.profile == null ) 
            {
                this.bill_from_charges_show_as = null;
                this.accept_visa = false;
                this.accept_ach = false;
                this.accept_mastercard = false;
                this.accept_amex = false;
                this.accept_discover = false;
                this.default_currency = 'USD';
                this.default_age_verification_requirement = 'none';
                this.vanity_url_portion = null;
                return;
            }

            let payment_settings = this.profile.organization_account.payment_settings;

            this.bill_from_charges_show_as = payment_settings.bill_from_charges_show_as;
            this.accept_visa = payment_settings.accept_visa;
            this.accept_ach = payment_settings.accept_ach;
            this.accept_mastercard = payment_settings.accept_mastercard;
            this.accept_amex = payment_settings.accept_amex;
            this.accept_discover = payment_settings.accept_discover;
            this.default_currency = payment_settings.default_currency;
            this.default_age_verification_requirement = payment_settings.default_age_verification_requirement;
            this.vanity_url_portion = payment_settings.vanity_url_portion;
        },
    },

    computed: {
        can_write() {
            return this.profile.actor_permissions.can_write; 
        },

        charges_show_as() {
            if ( this.profile == null ) return this.profile.organization_account.label;
            if ( this.profile.organization_account.bill_from == null ) return this.profile.organization_account.label;
            
            let bill_from = this.profile.organization_account.bill_from;

            let ret = bill_from.bill_from_charges_show_as;
            if ( ret == null ) return this.profile.organization_account.label;
            return ret;
        },

        vanity_url_hint()
        {
            if ( this.vanity_url_portion == null ) 
                return 'Make a payment url will be: https://app.redchirp.com/app/pay/{payment-id}';
            else
                return 'Make a payment url will be:  https://app.redchirp.com/app/pay/'+this.vanity_url_portion+'/{payment-id}';
        },
    },

    watch: {
        profile(newValue, oldValue) {
            this.setBooleansFromProfile();
        },
    },
}
</script>

<style lang="scss" scoped>

</style>